import { ToastProgrammatic as Toast } from "buefy";
import { authClient } from "@/auth0";
import store from "@/store";

export const loginCleanup = async (to: any, from: any, next: any) => {
  const isLoggedIn = await authClient.getIsAuthenticated();
  console.debug(`[GUARD] - [loginCleanup] - Is user logged in? ${isLoggedIn}`);

  if (!isLoggedIn) {
    authClient.isAuthenticated = false;
    console.debug(`[GUARD] - [loginCleanup] - Removing remaining tokens.`);
    store.commit("logout");
  }

  return next();
};

export const authGuard = async (to: any, from: any, next: any) => {
  console.debug(`[GUARD] - [authGuard] - Checking ${to.fullPath}`);

  const isLoggedIn = await authClient.getIsAuthenticated();

  if (isLoggedIn) {
    console.debug(`[GUARD] - [authGuard] - ${to.fullPath}  succeeded.`);
    return next();
  } else {
    console.debug(
      `[GUARD] - [authGuard] - ${to.fullPath} failed, redirecting to '/'`
    );

    Toast.open({
      type: "is-danger",
      message: "Du musst angemeldet sein, um diese Seite zu sehen.",
      duration: 3000,
      queue: false
    });
    return next("/logout");
  }
};

export const notAuthGuard = async (to: any, from: any, next: any) => {
  console.debug(`[GUARD] - [notAuthGuard] - Checking ${to.fullPath}`);

  const isLoggedIn = await authClient.getIsAuthenticated();

  if (isLoggedIn) {
    console.debug(
      `[GUARD] - [notAuthGuard] - ${to.fullPath} failed, go to /feed.`
    );
    return next("/feed");
  } else {
    console.debug(`[GUARD] - [notAuthGuard] - ${to.fullPath} succeeded.`);
    return next();
  }
};
